import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="public-footer" className="bg-[#050A1A] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-full bg-white p-1.5 flex items-center justify-center overflow-hidden ring-2 ring-[#FACC15]/40">
              <img src="/ssu-logo.jpg" alt="SSU" className="w-full h-full object-contain" />
            </div>
            <div className="leading-tight">
              <div className="font-display text-lg tracking-tight">SSU <span className="text-[#FACC15]">WORKSHOPS</span></div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/50">Members Only · 2026</div>
            </div>
          </div>
          <p className="text-sm text-white/60 max-w-sm">
            Superhero Swim University — Built for swim instructors who refuse to be average.
          </p>
          <div className="mt-5 pt-5 border-t border-white/10 text-xs text-white/60 leading-relaxed" data-testid="footer-venue">
            <div className="text-[10px] font-black uppercase tracking-[0.25em] text-[#FACC15] mb-1">The Venue · Oct 1–4, 2026</div>
            <div className="text-white/80 font-semibold">The Grand Hacienda Palm Beach</div>
            <a
              href="https://www.google.com/maps/search/?api=1&query=The+Grand+Hacienda+Palm+Beach+8028+Pioneer+Road+West+Palm+Beach+FL+33405"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#FACC15] transition-colors"
              data-testid="footer-address-link"
            >
              8028 Pioneer Road<br />West Palm Beach, FL 33405
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-widest text-[#FACC15] mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href="/#tickets" className="hover:text-[#FACC15]">Get Tickets</a></li>
            <li><Link to="/speak" className="hover:text-[#FACC15]" data-testid="footer-speak-link">Speaker Application</Link></li>
            <li><a href="https://www.skool.com/superheroswimuniversity/about" target="_blank" rel="noopener noreferrer" className="hover:text-[#FACC15]">Become a Member</a></li>
            <li><a href="#" className="hover:text-[#FACC15]">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-[#FACC15]">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-widest text-[#FACC15] mb-4">Follow</h4>
          <div className="flex gap-3">
            <a href="#" data-testid="footer-instagram" className="w-10 h-10 rounded-md border border-white/15 hover:border-[#FACC15] hover:text-[#FACC15] flex items-center justify-center transition-colors">
              <Instagram size={18} />
            </a>
            <a href="#" data-testid="footer-youtube" className="w-10 h-10 rounded-md border border-white/15 hover:border-[#FACC15] hover:text-[#FACC15] flex items-center justify-center transition-colors">
              <Youtube size={18} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © 2026 Superhero Swim University. All rights reserved.
      </div>
    </footer>
  );
}
